// src/lib/supabase.ts
import { createClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL as string
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY as string

export const supabase = createClient(url, anon, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
  global: {
    headers: {
      // Ensure PostgREST always sees the apikey
      apikey: anon,
      // Supabase-js will also attach Authorization: Bearer <access_token> after sign-in.
      // If you want to force anon credentials even before auth, you can also include:
      // Authorization is added automatically once a session exists.
    },
  },
})
